import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FaBriefcase, FaMapMarkerAlt, FaClock, FaArrowRight } from "react-icons/fa";
import "./JobDescription.css";

const JobDescription = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  // Function to calculate days ago
  const calculateDaysAgo = (postedDate) => {
    const today = new Date();
    const posted = new Date(postedDate);
    const diffTime = Math.abs(today - posted);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return `${diffDays} days ago`;
  };

  const jobs = [
    {
      id: 1,
      title: "Android Developer - Fresher",
      company: "Vero Disruptors",
      locations: ["Karnataka", "Andhra Pradesh", "Telangana"],
      workType: "Remote - Permanent",
      postedDate: "2025-03-24", // Using YYYY-MM-DD format for date calculation
      overview: "Vero Disruptors is seeking a talented Fresher Android Developer to join our innovative mobile development team. This is an excellent opportunity for recent graduates to kickstart their career in Android development with a focus on creating high-quality mobile applications.",
      responsibilities: [
        "Develop and maintain high-quality Android applications using Kotlin and Java",
        "Collaborate with cross-functional teams to design, develop, and implement new features",
        "Create intuitive, engaging, and visually appealing user interfaces",
        "Participate in code reviews and maintain code quality standards",
        "Assist in debugging and resolving technical issues"
      ],
      qualifications: {
        education: "BE/B Tech, ME/M Tech (IT, CSE, Data Science, ECE), MCA",
        mandatorySkills: [
          "Training completed in Android development",
          "Core Java",
          "Kotlin",
          "Android SDK",
          "Android UI Design",
          "Android Design Patterns",
          "English Communication"
        ],
        technicalSkills: [
          "Understanding of Activities, Fragments, Intents, Services",
          "Knowledge of Layouts, Views, and UI components",
          "Event handling and data binding",
          "Data persistence (Room Database, Firebase Realtime Database)",
          "Integration of third-party libraries and APIs",
          "Familiarity with MVVM architectural pattern",
          "Proficiency in Android Studio and debugging tools",
          "RESTful API integration"
        ]
      },
      additionalInfo: "Note: We are specifically looking for candidates trained in Android development. Due to resource constraints, we cannot consider profiles requiring cross-training from other technologies.",
      applicationProcess: [
        "Telephone screening interview",
        "Technical task assignment",
        "Assignment review and technical interview",
        "Final offer release"
      ],
      contact: "Submit your resume to: contact@verodisruptors.com",
      processTimeline: "Approximately 10 days depending on assignment submission"
    }
  ];

  const job = jobs.find((job) => job.id === parseInt(id));

  return (
    <div className="job-description-container">
      <div className="job-description-card">
        <h1 className="job-title">{job.title}</h1>
        

        <div className="job-meta">
          <div className="meta-item">
            <FaMapMarkerAlt className="meta-icon" />
            <span>{job.locations.join(", ")} (Remote)</span>
          </div>
          <div className="meta-item">
            <FaBriefcase className="meta-icon" />
            <span>{job.workType}</span>
          </div>
          <div className="meta-item">
            <FaClock className="meta-icon" />
            <span>Posted: 2 days ago</span>
          </div>
        </div>

        <section className="job-section">
          <h3>Overview</h3>
          <p>{job.overview}</p>
        </section>

        <section className="job-section">
          <h3>Responsibilities</h3>
          <ul className="job-list">
            {job.responsibilities.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </section>

        <section className="job-section">
          <h3>Qualifications</h3>
          <div className="qualifications-section">
            <h4>Education</h4>
            <p>{job.qualifications.education}</p>

            <h4>Mandatory Skills</h4>
            <ul className="job-list">
              {job.qualifications.mandatorySkills.map((skill, index) => (
                <li key={index}>{skill}</li>
              ))}
            </ul>

            <h4>Technical Skills</h4>
            <ul className="job-list">
              {job.qualifications.technicalSkills.map((skill, index) => (
                <li key={index}>{skill}</li>
              ))}
            </ul>
          </div>
        </section>

        <section className="job-section">
          <h3>Additional Information</h3>
          <p>{job.additionalInfo}</p>
        </section>

        <section className="job-section">
          <h3>Application Process</h3>
          <p>{job.processTimeline}</p>
          <ul className="job-list">
            {job.applicationProcess.map((step, index) => (
              <li key={index}>{step}</li>
            ))}
          </ul>
          <p className="contact-info">{job.contact}</p>
        </section>

        <button
          className="apply-button disabled"
          disabled
          title="Application functionality coming soon"
        >
          Apply Now <FaArrowRight className="button-icon" />
        </button>
      </div>
    </div>
  );
};

export default JobDescription;